import { render } from "./DeveloperSection.vue?vue&type=template&id=9c7a7e94"
import script from "./DeveloperSection.vue?vue&type=script&lang=js"
export * from "./DeveloperSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__